<template>
  <div id="chart-data-block" v-if="dataObj">
    <div class="card has-border">
      <div class="card-header pt-1 pb-1">
        Summary
        <span v-if="periodMode == 'this-month'"
          ><p class="text-secondary fs-800 mb-0">
            This Month
            <span class="text-primary fs-800 fw-700"
              >({{ currentMonthInText }})</span
            >
          </p></span
        >
        <span v-if="periodMode == 'last-month'"
          ><p class="text-secondary fs-800 mb-0">
            Last Month
            <span class="text-primary fs-800 fw-700"
              >({{ lastMonthInText }})</span
            >
          </p></span
        >
        <span v-if="periodMode == 'this-year'"
          ><p class="text-secondary fs-800 mb-0">
            This Year
            <span class="text-primary fs-800 fw-700"
              >({{ currentYearInText }})</span
            >
          </p></span
        >

        <b-spinner
          v-if="getDBDMIsDashboardLoading"
          label="Loading..."
          small
        ></b-spinner>
      </div>

      <div class="card-body">
        <dl class="row" v-if="isRecordType == 'settlements'">
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Settlements</dt>
          <dd class="col-sm-5 text-right fs-1000 fw-600 mb-0">
            {{ dataObj.dataTotSettlement }}
          </dd>
        </dl>

        <dl class="row" v-if="isRecordType == 'leads'">
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Leads</dt>
          <dd class="col-sm-5 text-right fs-1000 fw-600 mb-0">
            {{ dataObj.dataTotQuotes }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'WDDashboardSummary',
  props: ['dataObj', 'periodMode', 'isRecordType'],

  data() {
    return {
      currentMonthInText: '',
      lastMonthInText: '',
      currentYearInText: ''
    }
  },
  computed: {
    ...mapGetters(['getDBDMIsDashboardLoading'])
  },

  created() {
    this.currentMonthInText = moment().format('MMMM')
    this.lastMonthInText = moment().subtract(1, 'month').format('MMMM')
    this.currentYearInText = moment().format('YYYY')
  }
}
</script>
<style scoped>
.card.has-border {
  border: 1px solid;
}
</style>
